export default __webpack_public_path__ + "static/media/earn-coin-ico.d28830c8.svg";